<template>
  <el-option v-bind="$attrs" v-on="inputListeners">
    <slot></slot>
  </el-option>
</template>
<script>
export default {
  inheritAttrs: false,
  data: function() {
    return {};
  },
  computed: {
    inputListeners: function() {
      var vm = this;
      // `Object.assign` merges objects together to form a new object
      return Object.assign(
        {},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          input: function(event) {
            vm.$emit("input", event);
          }
        }
      );
    }
  }
};
</script>
